import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import { Spinner } from 'react-bootstrap';
import 'react-tooltip/dist/react-tooltip.css';

const TimelineTooltip = ({ tooltipId }) => {
  const [loaded, setLoaded] = useState(false);
  const [tooltipHidden, setTooltipHidden] = useState(false);

  const onHide = () => {
    setTooltipHidden(true);
    setLoaded(false);
  };

  const buildTooltipContent = (tooltipData) => {
    const data = JSON.parse(tooltipData);
    const { url, cameraName } = data ?? {};

    if (tooltipHidden && loaded == false) {
      return (
        <div>
          <div className="text-center font-weight-bold">{cameraName}</div>
          <div style={{ width: '420px', height: '310px' }}></div>
          <img
            style={{ display: 'none' }}
            onLoad={() => {
              setTooltipHidden(false);
            }}
            src="/assets/icons/search.svg"
          />
        </div>
      );
    }

    if (url) {
      return (
        <div>
          <div className="text-center font-weight-bold">{cameraName}</div>
          {loaded ? null : (
            <div style={{ width: '420px', height: '310px' }}>
              <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
              Loading...
            </div>
          )}
          <img
            onLoad={() => {
              setLoaded(true);
              setTooltipHidden(false);
            }}
            src={url}
            alt={url}
          />
        </div>
      );
    }
    return '';
  };

  return (
    <Tooltip
      class="image-timeline__tooltip"
      style={{ zIndex: 100, padding: 0 }}
      id={tooltipId}
      afterHide={onHide}
      //closeOnResize={true}
      globalCloseEvents={['resize', true]}
      render={({ content }) => buildTooltipContent(content)}
      disableStyleInjection="core"
    />
  );
};

TimelineTooltip.propTypes = {
  tooltipId: PropTypes.number.isRequired,
};

export default TimelineTooltip;
